import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { UrlPathCouponCreate } from "../../api/url";
import { canMaintainCoupons } from "../../store/actions/LoginActions";
import MenuLayout from "../app/MenuLayout";
import CouponTable from "./CouponTable";
import { useTranslation } from "react-i18next";

export const CouponPage = () => {
  const { t } = useTranslation();

  return (
    <MenuLayout headline={t("coupon.title")} subHeadline={t("coupon.subtitle")}>
      <Grid container spacing={2}>
        {canMaintainCoupons() && (
          <Grid container item justifyContent="flex-end">
            <Button component={Link} to={UrlPathCouponCreate} startIcon="+" variant="contained" color="primary">
              {t("coupon.newCoupon")}
            </Button>
          </Grid>
        )}
        <Grid item md={12}>
          <CouponTable />
        </Grid>
      </Grid>
    </MenuLayout>
  );
};